import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import InstallPrompt from "./components/InstallPrompt";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import PrivatePay from "./pages/PrivatePay";
import Hiring from "./pages/Hiring";
import FAQ from "./pages/FAQ";
import Booking from "./pages/Booking";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/toaster";
import { registerServiceWorker } from "./registerSW";
import { SiteContentProvider } from "./admin/SiteContentContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <InstallPrompt />}
    </>
  );
}

function App() {
  useEffect(() => { registerServiceWorker(); }, []);
  return (
    <div className="App bg-[#0a1020] text-slate-100 min-h-screen">
      <SiteContentProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Shell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/private-pay" element={<PrivatePay />} />
              <Route path="/hiring" element={<Hiring />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </Shell>
          <Toaster />
        </BrowserRouter>
      </SiteContentProvider>
    </div>
  );
}

export default App;
